module.exports = __webpack_public_path__ + "fonts/SF-Pro-Display-Thin.f35e9611.otf";